import { render, staticRenderFns } from "./PriceCreateDialog.vue?vue&type=template&id=64795b31&scoped=true"
import script from "./PriceCreateDialog.vue?vue&type=script&lang=ts"
export * from "./PriceCreateDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64795b31",
  null
  
)

export default component.exports